import {Row, Col, Table} from 'antd';
import {useEffect, useState} from 'react';
import {FaPlus} from 'react-icons/fa';
import {useIntl} from 'react-intl';
import {useParams} from 'react-router-dom';
import RejectionReasonsOptionModal from './rejection-reasons-option-modal';
import Button from 'src/shared/components/button';
import {popupConfirm} from 'src/shared/components/popup-confirm';
import TableColumn from './columns';
import {productRejectionReasonsService} from 'src/shared/services/product-rejection-reasons';
import {
  INDEX_PAGE_SIZE_DEFAULT,
  INDEX_PAGE_SIZE_OPTIONS,
} from 'src/shared/constants/AppConst';
import {GetAllReasonDescriptionsListDto} from 'src/shared/services/product-rejection-reasons/dto/get-all-reason-descriptions-list-dto';
import useTableV2 from 'src/shared/hooks/useTableV2';

interface IRejectionReasonsOptionsProps {}

const RejectionReasonsOptions = (props: IRejectionReasonsOptionsProps) => {
  const {messages} = useIntl();
  const {showTotal, ...tableV2} = useTableV2();

  const {id} = useParams();

  const [addOptionModalVisbility, setAddOptionModalVisbility] = useState(false);

  const [rejectionReasonsOptionList, setRejectionReasonsOptionList] = useState<
    GetAllReasonDescriptionsListDto[]
  >([]);

  const [rejectionReasonsOptionListTotal, setRejectionReasonsOptionListTotal] =
    useState(0);
  const [isRejectionReasonsOptionRefresh, setIsRejectionReasonsOptionRefresh] =
    useState(false);
  const [isRejectionReasonsOptionLoading, setIsRejectionReasonsOptionLoading] =
    useState(false);

  const [rejectionReasonsOptionDetails, setRejectionReasonsOptionDetails] =
    useState<GetAllReasonDescriptionsListDto>();

  const [pageSizeOptions] = useState<string[]>(INDEX_PAGE_SIZE_OPTIONS);
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: INDEX_PAGE_SIZE_DEFAULT,
  });

  useEffect(() => {
    if (id) {
      (async () => {
        setIsRejectionReasonsOptionLoading(true);
        try {
          let rejectionReasonsOptionObj =
            await productRejectionReasonsService.getAllRejectionReasonDescriptions(
              {
                reasonId: id,
                PageSize: pagination.pageSize,
                Page: pagination.page,
              },
            );
          setRejectionReasonsOptionList(rejectionReasonsOptionObj?.Data);
          setRejectionReasonsOptionListTotal(rejectionReasonsOptionObj.Total);
        } catch (error) {
          console.error(error);
        } finally {
          setIsRejectionReasonsOptionLoading(false);
        }
      })();
    }
  }, [id, isRejectionReasonsOptionRefresh, pagination]);

  const editRejectionReasonsOptionModal = (
    item: GetAllReasonDescriptionsListDto,
  ) => {
    setAddOptionModalVisbility(true);
    setRejectionReasonsOptionDetails(item);
  };

  const openOptionModal = () => {
    setAddOptionModalVisbility(true);
    setRejectionReasonsOptionDetails(undefined);
  };

  const onCancelModal = () => {
    setAddOptionModalVisbility(false);
  };

  const onFinishModal = async () => {
    setAddOptionModalVisbility(false);
    setIsRejectionReasonsOptionRefresh(!isRejectionReasonsOptionRefresh);
  };

  const renderAddOptionModal = () => {
    return (
      <RejectionReasonsOptionModal
        visible={addOptionModalVisbility}
        rejectionReasonsOptionDetails={rejectionReasonsOptionDetails}
        onCancel={onCancelModal}
        onFinish={onFinishModal}
      />
    );
  };

  const deleteRejectionReasonsOption = (
    item: GetAllReasonDescriptionsListDto,
  ) => {
    popupConfirm(async () => {
      try {
        await productRejectionReasonsService.deleteRejectionReasonDescription(
          item.Id,
        );
        setIsRejectionReasonsOptionRefresh(!isRejectionReasonsOptionRefresh);
      } catch (error) {
        console.error(error);
      }
    }, `${messages['commom.areYouSureYouWantToDelete'].toString()}` + ' ' + [item.Value] + `?`);
  };

  const tablePagination = {
    total: rejectionReasonsOptionListTotal,
    pageSizeOptions: pageSizeOptions,
    pageSize: pagination.pageSize,
    showSizeChanger: true,
    showTotal,
    current: pagination.page,
    onShowSizeChange: async (current: any, PageSize: any) => {
      setPagination({pageSize: PageSize, page: current});
    },
    onChange: (page: any, pageSize: any) => {
      setPagination({pageSize: pageSize, page: page});
    },
  };
  return (
    <Row gutter={[0, 20]}>
      <Col span={24}>
        <Row justify='end'>
          <Col>
            <Button
              icon={<FaPlus className='add-button-icon' />}
              onClickAction={openOptionModal}
              type='primary'
              text={messages[
                'specificationAttributes.edit.addNewOption'
              ].toString()}
              size='small'
              className='add-button'
            />
          </Col>
        </Row>
      </Col>
      <Col span={24}>
        <Table
          columns={TableColumn(
            editRejectionReasonsOptionModal,
            deleteRejectionReasonsOption,
          )}
          dataSource={rejectionReasonsOptionList}
          rowKey={(record: GetAllReasonDescriptionsListDto) =>
            record?.Id?.toString()
          }
          loading={isRejectionReasonsOptionLoading}
          bordered={true}
          pagination={tablePagination}
          {...tableV2}
        />
      </Col>

      {renderAddOptionModal()}
    </Row>
  );
};

export default RejectionReasonsOptions;
